import { OTPValidationResponse } from '@porterin/booking-flow/src/auth/domain/api-models/OtpValidationApiModel';
import { Customer } from '@porterin/booking-flow/src/auth/domain/entities/Customer';

const toCustomerEntity = (api: OTPValidationResponse): Customer => {
  const { customer } = api;
  return { authToken: customer.auth_token, mobile: customer.mobile };
};

export { toCustomerEntity };
